import { useState, useEffect, JSX } from 'react';
import PageLayout from 'global_elements/Layouts/PageLayout';
import { PageLayoutVariant } from 'global_elements/Layouts/PageLayout/variants';
import { NavBarVariant } from 'global_elements/Navigation/NavBar/variants';
import { FontColors, FontSizes } from 'global_elements/Text/variants';
import FlexContainer from 'global_elements/Layouts/FlexContainer';
import { AlignVariant, DisplayVariant, JustifyVariant } from 'global_elements/Layouts/FlexContainer/variants';
import TableauReportView from 'global_elements/TableauReportView/index.js';
import ReportsProxy from 'api/reports/reportsProxy';
import Paragraph from 'global_elements/Text/Paragraph';

const ERROR_MESSAGE = 'An error occurred while attempting to load Tableau. Please refresh the page to try again.';
const ERROR_MESSAGE_401 = 'An error occurred while attempting to load the report. Please contact your Administrator.';

const AdminReportsPage = (): JSX.Element => {
  const [isLoadingReport, setIsLoadingReport] = useState<boolean>(true);
  const [reportUrl, setReportUrl] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    setIsLoadingReport(true);
    ReportsProxy.getReport(0)
      .then((reportData) => {
        if (reportData !== null && reportData !== '') {
          setReportUrl(reportData);
          setErrorMessage('');
        } else {
          setErrorMessage(ERROR_MESSAGE);
        }
        setIsLoadingReport(false);
      })
      .catch((error) => {
        console.log(error);
        if (error.status === 401) {
          setErrorMessage(ERROR_MESSAGE_401);
        } else {
          setErrorMessage(ERROR_MESSAGE);
        }

        setIsLoadingReport(false);
      });
  }, []);

  return (
    <PageLayout layout={PageLayoutVariant.PADDED} testText="Reports Page" navBarVariant={NavBarVariant.PRIMARY} pageTitle="Reports">
      <FlexContainer display={DisplayVariant.FLEX_ROW} align={AlignVariant.START} justify={JustifyVariant.START}>
        {isLoadingReport ? (
          <div>
            <p data-testid="loading-report-detail">Loading...</p>
          </div>
        ) : (
          <>
            {errorMessage !== '' && <Paragraph text={errorMessage} fontColor={FontColors.HIGH_PRIORITY} fontSize={FontSizes.REGULAR} />}
            {errorMessage === '' && <TableauReportView url={reportUrl} />}
          </>
        )}
      </FlexContainer>
    </PageLayout>
  );
};

export default AdminReportsPage;
